const FALLBACK = '1565C0';

/** '#RRGGBB' -> [r, g, b] (para jsPDF). */
export function hexToRgb(hex: string): [number, number, number] {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
  const n = parseInt(m ? m[1] : FALLBACK, 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

/** '#RRGGBB' -> 'FFRRGGBB' (ARGB para exceljs). */
export function hexToArgb(hex: string): string {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
  return `FF${(m ? m[1] : FALLBACK).toUpperCase()}`;
}
